/* unplugin-vue-components disabled */
import {ROLES} from 'consts/roles'
import Role from '../role.vue'

export default {
  components: {Role},
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    visibleCount: {
      type: [Number, String],
      default: 4
    }
  },
  computed: {
    c_roles() {
      return $utils.array.getVisible(this.roles, +this.visibleCount)
    },
    more_text() {
      return this.c_roles.rest.map(x => ROLES.find(r => r.type === x).title ).join(', ')
    }
  }
}
